import { render, staticRenderFns } from "./StructureCard.vue?vue&type=template&id=33c4d8d8"
import script from "./StructureCard.vue?vue&type=script&lang=js"
export * from "./StructureCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports